import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import AcknowledgeModal from "./AcknowledgeModal";
import Constants from "../../../../common/Constants";
import { Row, Col, Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import ItemService from "../../../../services/commonService";
import ListGroup from "react-bootstrap/ListGroup";
import {
  fetchMasterListById,
  fetchMasterList,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
// import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import { ErrorModal } from "../../../common/errorModal";
import Form from "react-bootstrap/Form";
import { toastFunc } from "../../../../components/common/util";
import { useNavigate } from "react-router-dom";
import GenerateJobCardList from "./GenerateJobCardList";

const requiresMaterialTraceNumber = (jobcard) =>
  jobcard?.jobcardStatus === Constants.TRANSACTION_STATUS.OPEN &&
  jobcard?.toDeptCode === "DEPT001" &&
  !String(jobcard?.fromDeptCode || "").trim();

const AcknowledgeJobCard = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [jobcardDetails, setJobcardDetails] = useState();
  const [toDeptCode, setToDeptCode] = useState("");
  const [toDeptName, setToDeptName] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [toMachineCode, setToMachineCode] = useState("");
  const [isdisabled, setIsdisabled] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectedMissingTraceJobcards, setSelectedMissingTraceJobcards] =
    useState([]);
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [machineList, setMachineList] = useState([]);
  const [showChemicalBatch, setShowChemicalBatch] = useState("");
  const [clear, setClear] = useState(false);

  const formRef = useRef(null);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleClose = () => {
    // navigate("/home");
    setOpen(false);
  };
  const userData = useSelector((state) => state?.user);
  const deptCodeList = userData?.data?.departments?.map(
    (entry) => entry.deptCode,
  );
  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store

  const handleSuccess = async (decodedText, decodedResult) => {
    if (isProcessing) return; // Prevent multiple calls while processing
    setIsProcessing(true); // Set processing lock

    // This code is used to check and allow only valid jobcards to acknolewdge/
    let completeRowsData =
      masterList[Constants.TRANSACTION.GENERATEJOBCARD.open_jobcard.name]?.data;

    let rowsData = completeRowsData;
    if (userData?.data?.category === Constants.MASTER.USERS.TEAMLEAD) {
      rowsData = completeRowsData?.filter((user) =>
        deptCodeList?.includes(user?.toDeptCode),
      );
    }

    const matchedRecord = rowsData.find((item) => item.jobcard === decodedText);

    if (!matchedRecord) {
      setIsProcessing(false);
      toastFunc(
        Constants.MASTER.TOAST.error,
        "This jobcard is not assigned to you. ",
        5000,
      );
      return;
    }

    let param = {
      url: "getTransactionListDataById",
      page: Constants.TRANSACTION.GENERATEJOBCARD.name,
      jobcard: decodedText,
    };

    if (decodedText) {
      try {
        const item = await ItemService.getTransactionListDataById(param);
        if (item?.status === 200) {
          if (item?.data.length > 0) {
            if (
              item?.data[0]?.jobcardStatus === Constants.TRANSACTION_STATUS.OPEN
            ) {
              if (
                requiresMaterialTraceNumber(item?.data[0]) &&
                !String(item?.data[0]?.materialTraceNumber || "").trim()
              ) {
                handleClose();
                toastFunc(
                  Constants.MASTER.TOAST.error,
                  "Enter the Wire Trace Number before acknowledging this job card.",
                  5000,
                );
                return;
              }
              setOpen(false);
              setJobcardDetails(item.data[0]);
              setToDeptCode(item?.data[0]?.toDeptCode);
              setToDeptName(item?.data[0]?.toDeptName);
              await getChemicalBatchByDept(item?.data[0]?.toDeptCode);
            } else {
              handleClose();
              if (
                item?.data[0]?.jobcardStatus ===
                Constants.TRANSACTION_STATUS.COMPLETE
              ) {
                toastFunc(
                  Constants.MASTER.TOAST.error,
                  "Jobcard Completed",
                  5000,
                );
              } else {
                toastFunc(
                  Constants.MASTER.TOAST.error,
                  "Jobcard Already Acknowledged",
                  5000,
                );
              }
            }
          } else {
            if (decodedResult !== "") {
              handleClose();
              toastFunc(
                Constants.MASTER.TOAST.error,
                t("msg_trasaction.msg_teamlead_acknowledge.jobcard_not_found"),
                4000,
              );
            } else {
              toastFunc(
                Constants.MASTER.TOAST.error,
                t("msg_trasaction.msg_teamlead_acknowledge.jobcard_not_found"),
                4000,
              );
            }
          }
        } else {
          console.log(">> Error: Loading getApplicationMaster");
        }
      } catch (error) {
        console.error("Error in handleSuccess:", error);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_trasaction.msg_teamlead_acknowledge.error_occurred"),
          4000,
        );
      } finally {
        setIsProcessing(false); // Reset lock after completion
      }
    } else {
      setIsProcessing(false); // Reset lock if no decodedText is provided
    }
  };

  useEffect(() => {
    let param = {};
    param.url = "getMasterListDataById";
    param.page = Constants.MASTER.MACHINES.name;
    param.id = toDeptCode;

    if (toDeptCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        const filteredMachines = result?.payload?.data.filter(
          (machine) =>
            machine.runningStatus !== "Inuse" &&
            machine.status !== Constants.MASTER.STATUS.Inactive,
        );
        setMachineList(filteredMachines);
      });
    }
  }, [dispatch, toDeptCode]);

  const handleError = (errorMessage) => {
    console.error("ACK handleError:", errorMessage);
  };

  const handleInputValue = (value) => {
    // setInputValue(value); // Store input value in the parent state
    console.log("Input Value from Child: ", value);
    handleSuccess(value, "");
  };

  const resetError = () => {
    setIsError(false);
    setError("");
  };

  const handleConfirm = async () => {
    // Do not allow acknowledge if Batch Quantity is 0
    if (Number(jobcardDetails?.quantityPerJobCard || 0) <= 0) {
      toastFunc(
        Constants.MASTER.TOAST.error,
        "Batch Quantity cannot be zero. Please update the quantity before acknowledging this job card.",
        5000,
      );
      return;
    }

    if (
      requiresMaterialTraceNumber(jobcardDetails) &&
      !String(jobcardDetails?.materialTraceNumber || "").trim()
    ) {
      toastFunc(
        Constants.MASTER.TOAST.error,
        "Enter the Wire Trace Number before acknowledging this job card.",
        5000,
      );
      return;
    }

    setIsdisabled(true);
    const ackJobCardForm = {
      fromDeptCode: jobcardDetails.fromDeptCode,
      fromDeptName: jobcardDetails.fromDeptName,
      fromMachineCode: jobcardDetails.fromMachineCode,
      fromMachineName: jobcardDetails.fromMachineName,
      toDeptCode: toDeptCode,
      toDeptName: toDeptName,
      toMachineCode: toMachineCode?.machineCode,
      toMachineName: toMachineCode?.machineName,
      jobcard: jobcardDetails.jobcard,
      batchTotalQuantity: jobcardDetails.batchTotalQuantity,
      quantityPerJobCard: jobcardDetails.quantityPerJobCard,
      sizeCode: jobcardDetails.sizeCode,
      sizeName: jobcardDetails.sizeName,
      jobcardStatus: Constants.TRANSACTION_STATUS.ACKNOWLEDGE,
    };
    const param = {};
    param.ackJobCardForm = ackJobCardForm;

    // console.log("param ::", param);

    await ItemService.acknowlegedJobcard(param).then((item) => {
      if (item?.status === 200) {
        console.log(">> item! acknowlegedJobcard", item);
        //message
        if (item) {
          toastFunc(Constants.MASTER.TOAST.success, item?.message, 3000);
          // handleInputValue(jobcardDetails.jobcard, "");
          setJobcardDetails();
          setIsdisabled(false);
        } else {
        }
      } else {
        setIsdisabled(false);
        toastFunc(
          Constants.MASTER.TOAST.error,
          item?.message || "Unable to acknowledge the job card.",
          5000,
        );
      }
    });
  };

  const acknowledgeMultipleJobCards = async () => {
    if (selectedItem?.length === 0) {
      setError(t("msg_common.no_rows"));
      setIsError(true);
    } else if (selectedMissingTraceJobcards.length > 0) {
      setError(
        `Enter the Wire Trace Number before acknowledging: ${selectedMissingTraceJobcards.join(", ")}`,
      );
      setIsError(true);
    } else {
      const param = {
        jobCardList: selectedItem,
      };
      await ItemService.acknowlegedSelectedJobcards(param).then((item) => {
        if (item?.status === 200) {
          console.log(">> item! acknowleged SelectedJobcard", item);
          setTimeout(() => {
            dispatch(
              fetchMasterList(
                Constants.TRANSACTION.GENERATEJOBCARD.open_jobcard,
              ),
            );
          }, 1000);
          //message
          if (item) {
            toastFunc(Constants.MASTER.TOAST.success, item?.message, 3000);
            // handleInputValue(jobcardDetails.jobcard, "");
            setJobcardDetails();
            setIsdisabled(false);
          }
          setClear(true);
          setSelectedItem([]);
          setSelectedMissingTraceJobcards([]);
        } else {
          toastFunc(
            Constants.MASTER.TOAST.error,
            item?.message || "Unable to acknowledge the selected job cards.",
            5000,
          );
        }
      });
    }
  };

  const getChemicalBatchByDept = async (deptCode) => {
    let param = {
      deptCode,
    };
    await ItemService.getChemicalBatchByDept(param).then((item) => {
      // console.log(">>setShowChemicalBatch Details res!", item);
      if (item?.status === 200) {
        setShowChemicalBatch(item.data[0]);
      }
    });
  };

  const handleRowSelected = ({ selectedRows }) => {
    setClear(false);
    const selectJobcards = selectedRows.map((item) => item.jobcard);
    const missingTraceJobcards = selectedRows
      .filter(
        (item) =>
          requiresMaterialTraceNumber(item) &&
          !String(item.materialTraceNumber || "").trim(),
      )
      .map((item) => item.jobcard);
    setSelectedItem([...selectJobcards]);
    setSelectedMissingTraceJobcards([...missingTraceJobcards]);
  };

  return (
    <main className="acknowledgejobcard main" id="main">
      <Form noValidate ref={formRef}>
        <Card className="">
          <Card.Header>
            <Button
              type="button"
              variant="primary"
              className="btn btn-primary btn-xs navigateBackButton"
              onClick={() => {
                if (jobcardDetails?.jobcardStatus === undefined) {
                  navigate("/home");
                } else {
                  setJobcardDetails();
                }
              }}
            >
              <i class="bi bi-arrow-left back"> </i>
              <span className="back"> {t("msg_common.Back")}</span>
            </Button>

            <h5 className="machineStatusTitle"> {" Acknowledge JobCard "}</h5>
            {jobcardDetails?.jobcardStatus ===
              Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
              <p className="bg-table-status bg-table-success-status acknowledmentStatus">
                {jobcardDetails.jobcardStatus}
              </p>
            )}
            {jobcardDetails?.jobcardStatus === undefined && (
              <Button
                type="button"
                variant="primary"
                className="btnTable bg-table-status bg-table-success-status acknowledmentStatus"
                onClick={() => setOpen(true)}
              >
                <i className="bi bi-qr-code mr-2"></i>
                {t("msg_common.QrButton")}
              </Button>
            )}
          </Card.Header>
          {jobcardDetails?.jobcardStatus === undefined ? (
            <Card.Body className="ps-3">
              <GenerateJobCardList
                handleInputValue={handleInputValue}
                handleAckAllJobCards={acknowledgeMultipleJobCards}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={clear}
              />
            </Card.Body>
          ) : (
            <Card.Body className="ps-3">
              <Row className="ps-3">
                <Col lg={6} md={6} sm={12}>
                  <Row>
                    <Col lg={4} md={4} sm={12}>
                      <h5>From Department :</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                      {jobcardDetails.fromDeptCode && (
                        <h5>
                          <span className="bg-table-status bg-table-new-status py-0">
                            {jobcardDetails.fromDeptCode}{" "}
                            {jobcardDetails.fromDeptName}
                          </span>
                        </h5>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Row>
                    <Col lg={4} md={4} sm={12}>
                      <h5>To Department :</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                      <h5>
                        <span className="bg-table-status bg-table-new-status py-0">
                          {jobcardDetails.toDeptCode} -{" "}
                          {jobcardDetails.toDeptName}
                        </span>
                      </h5>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br />
              <Row className="ps-3">
                <Col lg={6} md={6} sm={12}>
                  <Row>
                    <Col lg={2} md={2} sm={12}>
                      <h5> Chemical :</h5>
                    </Col>
                    <Col lg={10} md={10} sm={12}>
                      {showChemicalBatch && (
                        <>
                          <span className="bg-table-status bg-table-new-status py-0 mx-1">
                            Batch: {showChemicalBatch?.chemicalBatchNo}
                          </span>
                        </>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  {/* Removed Machine Selection Based on requirement. */}
                  {/* <Row>
                    <Col lg={4} md={4} sm={12}>
                      <h5> To Machine :</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                      <h5>
                        {jobcardDetails?.jobcardStatus ===
                        Constants.TRANSACTION_STATUS.ACKNOWLEDGE ? (
                          jobcardDetails.toMachineCode ? (
                            <span className="bg-table-status bg-table-new-status py-0">
                              {jobcardDetails.toMachineCode} -{" "}
                              {jobcardDetails.toMachineName}
                            </span>
                          ) : (
                            <span className="bg-table-status bg-table-danger-status py-0">
                              Not Assigned
                            </span>
                          )
                        ) : (
                          <DropdownListField
                            id="machineCode"
                            name="machineCode"
                            className="dropdownHive w-full rounded-md"
                            data={machineList}
                            //value={planType}
                            onChange={(e) => {
                              setToMachineCode(e);
                            }}
                            // required
                            placeholder={"Select To Machine"}
                            // disabled={disableMachineArr}
                          />
                        )}
                      </h5>
                    </Col>
                  </Row> */}
                </Col>
              </Row>
              <br />
              <Card>
                <Row>
                  <Col lg={6} md={6} sm={12}>
                    <ListGroup variant="flush" className="jobcard-detail-list">
                      <ListGroup.Item>
                        <span>Customer : </span>{" "}
                        {jobcardDetails.customerCode}{" "}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>Required Date : </span>{" "}
                        {jobcardDetails.requiredDate}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>Plan : </span> {jobcardDetails.plan}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>Total Quantity : </span>{" "}
                        {jobcardDetails.batchTotalQuantity}
                      </ListGroup.Item>
                      {jobcardDetails?.jobcardStatus ===
                        Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                        <ListGroup.Item className="m-2"></ListGroup.Item>
                      )}
                    </ListGroup>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <ListGroup variant="flush" className="jobcard-detail-list">
                      <ListGroup.Item>
                        <span>Size : </span> {jobcardDetails.sizeCode} (
                        {jobcardDetails.sizeName})
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>Sl Card No : </span> {jobcardDetails.jobcard}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>Job Card Number : </span> {jobcardDetails.jobcard}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>Batch Quantity : </span>{" "}
                        {jobcardDetails.quantityPerJobCard}
                      </ListGroup.Item>
                      {jobcardDetails?.jobcardStatus ===
                        Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                        <ListGroup.Item></ListGroup.Item>
                      )}
                    </ListGroup>
                  </Col>
                </Row>
              </Card>
            </Card.Body>
          )}

          {jobcardDetails?.jobcardStatus &&
            jobcardDetails?.jobcardStatus !==
              Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
              <Card.Footer className="text-center machine-status-footer-button">
                <Button
                  type="button"
                  variant="success"
                  size="lg"
                  className="btn btn-success"
                  disabled={isdisabled}
                  onClick={() => handleConfirm()}
                  data-dismiss="modal"
                >
                  {"CONFIRM"}
                </Button>

                <Button
                  type="button"
                  variant="danger"
                  size="lg"
                  className="btn btn-danger"
                  onClick={() => setJobcardDetails()}
                  data-dismiss="modal"
                >
                  {t("msg_common.set_cancel")}
                </Button>
              </Card.Footer>
            )}
        </Card>
        {open && (
          <AcknowledgeModal
            show={open}
            onHide={handleClose}
            handleSuccess={handleSuccess}
            handleError={handleError}
            onButtonClick={handleInputValue}

            //onSave={handleSave}
          ></AcknowledgeModal>
        )}
        {isError && (
          <ErrorModal
            show={isError}
            heading={t(
              "msg_trasaction.msg_generatejobcard.Acknowledge_jobcard",
            )}
            bodyMessage={error}
            onHide={() => {
              resetError();
            }}
          ></ErrorModal>
        )}
      </Form>
    </main>
  );
};

export default AcknowledgeJobCard;
